import { useEffect, useState } from 'react'
import { Outlet, useNavigate } from 'react-router-dom'
import clsx from 'clsx'
import { Tab, TabList, TabPanel, TabPanels, TabGroup } from '@headlessui/react'
import { useLocale } from '../../hooks/useLocale'
import { useAuth } from '../../hooks/useAuth'

const HupoPerspectivesPage = () => {
  const { t } = useLocale()
  const navigate = useNavigate()
  const { user } = useAuth()

  const canShowEndJourney = !!user?.endJourneyInitiated

  const [selectedTab, setSelectedTab] = useState<
    'start-of-journey' | 'end-of-journey'
  >('start-of-journey')

  useEffect(() => {
    const url = new URL(window.location.href)
    const pathname = url.pathname
    if (pathname.includes('end-of-journey')) {
      setSelectedTab('end-of-journey')
    } else if (pathname.includes('start-of-journey')) {
      setSelectedTab('start-of-journey')
    }
  }, [])

  return (
    <div className="w-full bg-white rounded-[20px] p-6">
      <TabGroup
        selectedIndex={selectedTab === 'end-of-journey' ? 0 : 1}
        onChange={(index) => {
          const newTab = index === 0 ? 'end-of-journey' : 'start-of-journey'
          setSelectedTab(newTab)
          navigate(`/hupo-perspectives/${newTab}`)
        }}
      >
        <TabList
          className={clsx(
            'flex rounded-[20px]',
            canShowEndJourney ? 'bg-[#F8F9FA] p-1.5' : ''
          )}
        >
          {['end_of_journey', 'start_of_journey'].map((tab) => (
            <Tab
              key={tab}
              value={tab}
              className={({ selected }) =>
                clsx(
                  'w-1/2 rounded-[12px] text-sm font-medium leading-5 transition-all',
                  selected
                    ? 'bg-white text-gray-900 shadow-[0_1px_3px_0_rgba(0,0,0,0.1)]'
                    : 'text-gray-500 hover:text-gray-700',
                  canShowEndJourney ? 'py-2.5' : 'hidden'
                )
              }
            >
              {t(tab)}
            </Tab>
          ))}
        </TabList>
        <TabPanels className="mt-6">
          <TabPanel>
            <Outlet />
          </TabPanel>
          <TabPanel>
            <Outlet />
          </TabPanel>
        </TabPanels>
      </TabGroup>
    </div>
  )
}

export default HupoPerspectivesPage
